
let students, teachers;

function fetchUsers() {
/*This function fetches a list of users from a server API and updates their properties for later use in a messaging feature. 
it takes no parameters and returns a promise.*/

	//The HTTP method is set to post
	return this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
		{
			method: "post",
		}
	)
	.then(json => {//
		if (json.status.toLowerCase() === "success") {
			/*If the JSON response works correctly, then we extract
			students and teachers properties from the JSON object*/
			students = json.students;
			teachers = json.teachers;

			/*Then, we update their respective properties to include the booleans isTeacher and isStudent*/
			// need some way to select only teachers/students in the new message screen
			for(let student of students) {
				student.isStudent = true;
				student.isTeacher = false;
			}
			for(let teacher of teachers) {
				teacher.isStudent = false;
				teacher.isTeacher = true;
			}

		} else { //If the JSON response fails, then we log the error. 
			this.$log.error.call(this, "Could not fetch users");
		}
	})
	.catch(error => { //If there is any error, we log it
		this.$log.error.call(this,error);
	});

}

function findUserById(id){
	/* The functions takes an id and returns either the matching teacher or student object.
	 If no object is found with the given id, the function returns null.*/
	for(let teacher of teachers) {
		if(teacher.id == id){
			return teacher;
		}
	};
	for(let student of students) {
		if(student.id == id){
			//console.log(JSON.stringify(item));
			return student;
		}
	};
	return null;
}

export default {
	refresh() {//Fecth users basedon the current context
		fetchUsers.call(this);
	},

	clearData() {//Clears the data for students and teachers objects
		students = null;
		teachers = null;
	},

	getStudents() {
		//The function returns a promise
		return new Promise((resolve/*, reject*/) => {
			if(students) { //First we check if students we have student data, if so, the promise return the value of students
				resolve(students);
			} else {//If not, we retrieve the student data
				fetchUsers.call(this).then(() => {
					resolve(students);
				})
			}
		})
	},

	getTeachers() {
		//Similar to getStudents
		return new Promise((resolve/*, reject*/) => {
			if(teachers) {
				resolve(teachers);
			} else {
				fetchUsers.call(this).then(() => {
					resolve(teachers);
				})
			}
		})
	} ,

	getUserById(id) {
		//Similar to getStudents
		return new Promise((resolve/*, reject*/) => {
			if(teachers) {
				resolve(findUserById(id));
			} else {
				fetchUsers.call(this).then(() => {
					resolve(findUserById(id));
				})
			}
		})
	},
	getDisplayName(id) {
		return new Promise((resolve/*, reject*/) => {
			if(teachers) {//If there is teachers data, we store the data associated to the id
				var item = findUserById(id);
				if(item){//Then, we resolve the Promise by returning the display name associated to the id
					resolve(item.displayName);
				}
			} else {/*If there is not teachers data, then we retrieve it and search for a user with an specific id.
					The order of execution gurantees that the display name is returned only after the list of users has been retrieved and the specified user has been found.*/
				fetchUsers.call(this).then(() => {
					var item = findUserById(id);
					if(item){
						resolve(item.displayName);
					}
				})
			}
		})
	},
}
